import GlobalTable from '@/components/probaworkflows_base_components/GlobalTable/GlobalTable.vue';
import {
  CREATE_SUB_ENTITY_URL,
  GET_ALL_SUB_ENTITIES,
  get_headers,
  UPDATE_SUB_ENTITY_URL,
} from '@/utils/constants/constants.js';
import alert_mixin from '@/utils/mixins/alert_mixin';
import formatting_mixins from "@/utils/mixins/formatting_mixins";
import { validate_non_empty_string } from '@/utils/validations/validate_inputs';
import axios from 'axios';

export default {
  name: 'SubEntities',
  mixins: [alert_mixin, formatting_mixins],
  components: {
    GlobalTable
  },
  data: () => ({
    headers: get_headers(),
    sub_entities: [],
    edit_subentity_id: null,
    edit_subentity_name: '',
    edit_subentity_description: '',
    subentity_name: '',
    subentity_description: '', 
    project_id: sessionStorage.getItem('project_id'),
    table_safe_form_list: [],
    table_headers: [],
    is_loading: false,
  }),
  mounted() {
    this.load_data();
  },

  methods: {
    async load_data() {
      await this.show_loader("Loading sub-entities...")
        .then(async loader => {
          this.is_loading = true;
          try {
            await this.get_all_sub_entities();
            return this.close_loader(loader);
          } catch (error) {
            this.show_error('Error loading sub-entities: ' + error);
            return this.close_loader(loader);
          } finally {
            this.is_loading = false;
          }
        });
    },

    open_edit_subentity_modal(entity) {
      this.edit_subentity_id = entity.id;
      this.edit_subentity_name = entity.name;
      this.edit_subentity_description = entity.description;
    },

    open_create_subentity_modal() {
      this.subentity_name = '';
      this.subentity_description = '';
    },

    async create_subentity() {
      if (!validate_non_empty_string(this.subentity_name)) {
        this.show_error('Sub entity name is required.');
        return;
      }

      const payload = {
        project_id: this.project_id,
        sub_entity_name: this.subentity_name,
        sub_entity_description: this.subentity_description
      };

      await this.show_loader("Creating sub-entity...")
        .then(async loader => {
          return axios.post(CREATE_SUB_ENTITY_URL, payload, { headers: this.headers })
            .then(response => {
              const response_data = JSON.parse(response.data);
              const { status, message } = response_data;
              if (status === 'success') {
                this.close_modal('create_subentity_modal');
                this.show_success('Sub entity created successfully.');
                return this.get_all_sub_entities()
                  .then(() => this.close_loader(loader));
              } else {
                this.show_error('Error creating Sub entity: ' + (message || 'Unknown error'));
                this.close_modal('create_subentity_modal');
                return this.close_loader(loader);
              }
            })
            .catch(error => {
              this.show_error('Error creating Sub entity: ' + (error.response?.data?.message || 'An unexpected error occurred'));
              this.close_modal('create_subentity_modal');
              return this.close_loader(loader);
            });
        });
    },

    async get_all_sub_entities() {
      this.sub_entities = [];
      try {
        let response = await axios.get(GET_ALL_SUB_ENTITIES, {
          headers: this.headers,
          params: { project_id: this.project_id },
        });

        const response_data = response.data;
        if (response_data.status === 'success') {
          this.sub_entities = response_data.data;
          this.prep_tables();
        } else {
          this.table_safe_form_list = [];
          this.show_error('Error during retrieval of sub entities');
        }
      } catch (error) {
        if (error.response && error.response.data) {
          this.show_error('Error during the retrieval of sub entities:', error.response.data.message);
        }
      }
    },

    prep_tables() {
      this.table_safe_form_list = [];
      
      if (this.sub_entities.length > 0) {
        this.table_safe_form_list = this.sub_entities.map((sub_entity) => ({
          "id": sub_entity.id,
          "name": sub_entity.sub_entity_name,
          "Description": sub_entity.description || '-',
        }));
        this.table_headers = Object.keys(this.table_safe_form_list[0]);
      } else {
        this.table_headers = ["ID", "name", "Description"];
      }
    },

    async update_subentity() {
      if (!validate_non_empty_string(this.edit_subentity_name)) {
        this.show_error('Sub entity name is required.');
        return;
      }

      const payload = {
        id: this.edit_subentity_id,
        sub_entity_name: this.edit_subentity_name,
      };

      await this.show_loader("Updating sub-entity...")
        .then(async (loader) => {
          axios.post(UPDATE_SUB_ENTITY_URL, payload, { headers: this.headers })
            .then(async (response) => {
              const response_data = JSON.parse(response.data);
              if (response_data.status === 'success') {
                this.close_modal('edit_subentity_modal');
                this.show_success('Sub entity updated successfully.');
                await this.get_all_sub_entities();
              } else {
                this.show_error('Error updating Sub entity: ' + (response_data.message || 'Unknown error'));
              }
            })
            .catch((error) => {
              this.show_error(
                'Error updating Sub entity: ' + (error.response?.data?.message || 'An unexpected error occurred')
              );
            })
            .finally(() => {
              this.close_loader(loader);
            });
        });
    }
  }
};